module.exports = __webpack_public_path__ + "ce58d4379d609420be90edc8be0a0b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-thank-you.png
// module id = 2035
// module chunks = 4